module.exports = __webpack_public_path__ + "static/media/dharma-precision-tools.50e66a94.png";